/* split-test vertical_grid_infinite_scroll_v2 */

import './vertical-grid.css';

import './img/blank.png';
